"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureArray = void 0;
const ensureArray = (subject) => Array.isArray(subject) ? subject : [subject];
exports.ensureArray = ensureArray;
//# sourceMappingURL=ensureArray.js.map